import { createIcon } from './icon-utils';

export const ItalicIcon = createIcon({
  path: 'M16.941 4.289l-8.166 14.7h2.662a.75.75 0 1 1 0 1.5H3.563a.75.75 0 1 1 0-1.5H7.06l8.166-14.7h-2.662a.75.75 0 1 1 0-1.5H20.437a.75.75 0 1 1 0 1.5h-3.496z',
});
